import { Container } from '@mui/material'
import RegisterAccess from '../../../../../utils/registerAccess'
import AutorizacoesExercicioEmitidas from '../../../../gestLicenciados/autorizacaoExercicio/autorizacoesExercicioEmitidas'
import HeaderSession from '../../../../../utils/headerSession'

export default function TemplateRelatorioAutorizacoesExercicioEmitidas() {
  return (
    // <Container style={{ maxWidth: 900, padding: 8 }}>
    <>
      <RegisterAccess page={'Relatório de Autorizações de Exercício Emitidas'} />
      <HeaderSession title={'AUTORIZAÇŌES DE EXERCíCIOS EMITIDAS'} />

      {/* {component} */}

      <AutorizacoesExercicioEmitidas geral={true} />
    </>
  )
}
